import { mapCityDetailResponse } from 'app/functions/api';
import { isNumeric } from 'app/functions/string';
import { fetchCityRelationDetails, fetchTranslations } from 'app/providers';
import {
    loadUi,
    requestTranslationsSucceeded,
    setArrivalLocation,
    setDepartureLocation,
    storeCityDetail,
    UPDATE_OPTIONS,
} from 'app/store/actions';
import {
    arrivalCitySelector,
    departureCitySelector,
    optionsSelector,
} from 'app/store/selectors';
import { takeLatest, select, put, call, all } from 'redux-saga/effects';

function* requestTranslations(locale) {
    try {
        const translationsResponse = yield call(fetchTranslations, locale);
        const translationsJson = yield call([translationsResponse, translationsResponse.json]);

        yield put(requestTranslationsSucceeded(translationsJson));
    } catch (error) {
        // @todo: handle error
    }
}

function* requestLocalizedCities({ locale, citiesDetailsEndpoint, initialSearchMaskValues }) {
    const departureCity = yield select(departureCitySelector);
    const arrivalCity = yield select(arrivalCitySelector);

    // If we already have the names then we don't need to fetch details
    if (departureCity.name && arrivalCity.name) {
        return;
    }

    try {
        const citiesDetailsResponse = yield call(
            fetchCityRelationDetails,
            citiesDetailsEndpoint,
            departureCity.id || departureCity.legacyId,
            arrivalCity.id || arrivalCity.legacyId,
            locale,
        );

        const [departureCityResponse, arrivalCityResponse] = citiesDetailsResponse;

        yield all([
            put(storeCityDetail(locale, mapCityDetailResponse(departureCityResponse))),
            put(storeCityDetail(locale, mapCityDetailResponse(arrivalCityResponse))),
        ]);

        const {
            departureCity: departureCityId,
            arrivalCity: arrivalCityId,
        } = initialSearchMaskValues;

        // normalize legacyIds to their hashes
        if (isNumeric(departureCityId)) {
            yield put(setDepartureLocation(departureCityResponse.id));
        }

        if (isNumeric(arrivalCityId)) {
            yield put(setArrivalLocation(arrivalCityResponse.id));
        }
    } catch (error) {
        // noop
    }
}

function* onUpdateOptions(action) {
    const oldOptions = yield select(optionsSelector);
    const newOptions = { ...oldOptions, ...action.options };

    yield all([
        requestTranslations(newOptions.locale),
        requestLocalizedCities(newOptions),
    ]);

    yield put(loadUi());
}

export function* updateOptionsWatcher() {
    yield takeLatest(UPDATE_OPTIONS, onUpdateOptions);
}
